import React from 'react';

import { borderRadius, spacing, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

interface ITextWithBackgroundProps {
  color: string;
  text: string;
}

interface IColors {
  color: string;
  backgroundColor: string;
}

interface IColorObj {
  [key: string]: IColors;
}

const colors = {
  darkGreen: {
    color: '#40916C',
    backgroundColor: '#00FF941A',
  },
  purple: {
    color: '#6F60DD',
    backgroundColor: '#6F60DD1A',
  },
  green: {
    color: '#3FD077',
    backgroundColor: '#3FD0771A',
  },
  red: {
    color: '#FB6376',
    backgroundColor: '#FB63761A',
  },
  maroon: {
    color: '#95619C',
    backgroundColor: '#E8C2D233',
  },
  peach: {
    color: '#F4B583',
    backgroundColor: '#F4B5831A',
  },
  default: {
    color: publicaColors.black,
    backgroundColor: 'none',
  },
} as IColorObj;

export const TextWithBackground = (props: ITextWithBackgroundProps) => {
  const { color, text } = props;

  const colorObj = colors[color] || colors.default;

  return (
    <Text
      small
      bold
      color={colorObj.color}
      style={{
        backgroundColor: colorObj.backgroundColor,
        borderRadius: borderRadius.small,
        width: 'fit-content',
        padding: `${spacing.none} ${spacing.small}`,
      }}
    >
      {text}
    </Text>
  );
};
